/**
 * Extrae palabras de una fórmula matemática y las traduce
 * @param {string} formula - Fórmula con variables (ej: "2*(Height+Length)/Distance")
 * @param {Function} t - Función de traducción de vue-i18n
 * @returns {string} - Fórmula con las variables traducidas
 */
export function translateFormula(formula, t) {
  if (!formula || typeof formula !== 'string') return formula

  // Patrón CORREGIDO: Identifica variables (palabras que no son números puros)
  // Variables válidas: comienzan con letra o _, pueden contener números después
  const variablePattern = /\b[a-zA-Z_][a-zA-Z0-9_]*\b/g

  // Encontrar todas las variables en la fórmula
  const variables = formula.match(variablePattern) || []

  // Si no hay variables, retornar la fórmula original
  if (variables.length === 0) return formula

  // Crear un objeto con las traducciones
  const translations = {}
  variables.forEach((variable) => {
    if (!translations[variable]) {
      try {
        const translation = t(variable.toLowerCase(), 1)
        // Solo usar la traducción si es diferente y no está vacía
        if (translation && translation !== variable) {
          translations[variable] = translation
        }
      } catch (error) {
        // Si hay error, mantener la variable original
        translations[variable] = variable
      }
    }
  })

  // Reemplazar las variables con sus traducciones
  let translatedFormula = formula
  Object.entries(translations).forEach(([original, translated]) => {
    // Usar una expresión regular con word boundary para reemplazo exacto
    const regex = new RegExp(`\\b${original}\\b`, 'g')
    translatedFormula = translatedFormula.replace(regex, translated)
  })

  return translatedFormula
}
